export const getBrandName = () => {
  return process.env.REACT_APP_WEBSITE_BRAND?.toLowerCase()
}

export const getServiceBrandName = () => {
  const brand = getBrandName()
  switch (brand) {
    case 'vw6':
      return 'vw'
    case 'vwcv':
    case 'vwc':
      return 'vwn'
    case 'dealer':
      return 'vw'
    default:
      return brand
  }
}

export const getBronsonBrand = (brand = getBrandName()) => {
  switch (brand) {
    case 'vwfs':
      return 'bluelabel'
    case 'vw':
    case 'vwcv':
    case 'vwc':
    case 'vwn':
      return 'vw6'
    case 'dealer':
      return 'bluelabel'
    default:
      return brand
  }
}

export const getManufacturerName = () => {
  return getServiceBrandName()
}

export const keycloakBrand = (() => {
  const brand = getBrandName()
  switch (brand) {
    case 'vw6':
      return 'vw'
    case 'vwc':
      return 'vwcv'
    case 'dealer':
      return 'vw'
    default:
      return brand
  }
})()
